import { render, staticRenderFns } from "./horizontal-bar.vue?vue&type=template&id=832b4cc0&"
import script from "./horizontal-bar.vue?vue&type=script&lang=js&"
export * from "./horizontal-bar.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('832b4cc0')) {
      api.createRecord('832b4cc0', component.options)
    } else {
      api.reload('832b4cc0', component.options)
    }
    module.hot.accept("./horizontal-bar.vue?vue&type=template&id=832b4cc0&", function () {
      api.rerender('832b4cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/review-stats/horizontal-bar.vue"
export default component.exports